export function hasAccess(pageName) {
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    return roles.includes("Super Admin") || roles.includes(pageName);
}